// Fetch + parse scene.json and manifest.json from a bundle base URL
// (e.g. "/viewer_data/<hash>"), as written by scripts/export_viewer.py.

import type { Manifest, Scene } from "./types";

async function fetchJson<T>(url: string): Promise<T> {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`fetch ${url} failed: ${r.status} ${r.statusText}`);
  return (await r.json()) as T;
}

export async function loadScene(baseUrl: string): Promise<Scene> {
  return fetchJson<Scene>(`${baseUrl}/scene.json`);
}

export async function loadManifest(baseUrl: string): Promise<Manifest> {
  return fetchJson<Manifest>(`${baseUrl}/manifest.json`);
}
